import {EnumLanguage} from "../EnumLanguage";

export const UXProfile = {
    title: {
        [EnumLanguage.ru]: 'Личный кабинет',
        [EnumLanguage.en]: 'Your account',
        [EnumLanguage.cn]: '您的帐户'
    }
}